import { render, staticRenderFns } from "./ProjectDetailsComponent.vue?vue&type=template&id=13462058&"
import script from "./ProjectDetailsComponent.vue?vue&type=script&lang=js&"
export * from "./ProjectDetailsComponent.vue?vue&type=script&lang=js&"
import style0 from "./ProjectDetailsComponent.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports